import React, { useEffect, useMemo, useState } from "react";
import { CalculateOutlined, Close } from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";
import { Modal } from "../../modal";

export type PopupFormSavedData = {
  formId: string | number;
  rowId: string | number;
  values: Record<string, any>;
};

type Props = {
  url: string;
  onSaved: (data: PopupFormSavedData) => void;
};

const PopUpFormLink = ({ url, onSaved }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const popupUrl = useMemo(() => {
    const nextUrl = new URL(url, window.location.origin);

    nextUrl.searchParams.set("popupForm", "1");
    nextUrl.searchParams.set(
      "popupParentOrigin",
      window.location.origin,
    );

    return nextUrl.toString();
  }, [url]);

  useEffect(() => {
  if (!isOpen) {
    return;
  }

  const handleMessage = (event: MessageEvent) => {
    if (event.data?.type !== "popup-form-saved") {
      return;
    }

    setIsOpen(false);

    try {
      onSaved(event.data.payload);
    } catch (error) {
      console.error(
        "[PopupFormLink] failed while applying popup values",
        error,
      );
    }
  };

  window.addEventListener("message", handleMessage);

  return () => window.removeEventListener("message", handleMessage);
}, [isOpen, onSaved]);

  return (
    <>
      <Tooltip title="Open linked form">
        <IconButton
          type="button"
          size="small"
          aria-label="Open linked form"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();

            setIsOpen(true);
          }}
          sx={{ ml: 0.5, p: 0.25, verticalAlign: "middle" }}
        >
          <CalculateOutlined fontSize="small" />
        </IconButton>
      </Tooltip>

      <Modal isOpen={isOpen} handleClose={() => setIsOpen(false)}>
        <Box sx={{ position: "relative", minHeight: "76vh" }}>
          <IconButton
            type="button"
            aria-label="Close popup form"
            onClick={() => setIsOpen(false)}
            sx={{ position: "absolute", top: -12, right: -12, zIndex: 1 }}
          >
            <Close />
          </IconButton>

          <iframe
            title="Popup form"
            src={popupUrl}
            style={{
              width: "100%",
              height: "76vh",
              minHeight: 460,
              border: 0,
            }}
          />
        </Box>
      </Modal>
    </>
  );
};

export default PopUpFormLink;